import { InputText } from '@turbocomplynpm/input-text';

export default InputText;
